import { FC } from "react"
// import { useSelector, useDispatch } from 'react-redux'
// import { SelectedItemIdContext } from '../VisualizeItemEditor'
// import { selectRoiItemColors } from 'store/slice/VisualizeItem/VisualizeItemSelectors'
// import { setRoiItemColors } from 'store/slice/VisualizeItem/VisualizeItemSlice'
// import { useFileUploader } from 'store/slice/FileUploader/FileUploaderHook'
// import { FILE_TYPE_SET } from 'store/slice/InputNode/InputNodeType'
// import { ColorType } from 'store/slice/VisualizeItem/VisualizeItemType'

export const RoiItemEditor: FC = () => {
  // const itemId = useContext(SelectedItemIdContext)
  // const dispatch = useDispatch()
  // const { onUploadFile } = useFileUploader(FILE_TYPE_SET.CSV)
  // const onUploadFileHandle = (formData: FormData, fileName: string) => {
  //   onUploadFile(formData, fileName)
  // }

  // const colors = useSelector(selectRoiItemColors(itemId))
  // const dispathSetColor = (colorCode: ColorType[]) => {
  //   dispatch(setRoiItemColors({ itemId, colors: colorCode }))
  // }

  return (
    <>
      {/* <GradientColorPicker /> */}
      {/* <GradientColorPicker colors={colors} dispatchSetColor={dispathSetColor} /> */}
    </>
  )
}
